export default {
  'm': {
    'EnterID': 'クリックしてBuzzCast IDを入力します',
    'select-specifications': 'クリックしてチャージ種類を選択します',
    'check-account': 'リチャージアカウントを確認します',
    'whatID': 'BuzzCast ID とは？',
    'getID': 'BuzzCast ID を入力します',
    'maskgetID': 'BuzzCast ID を入力します',
    'toastTips-format-error': '入力フォーマットが正しくありません',
    'toastTips-no-exist': 'ID は存在しません',
    'toastTipsPlease': 'まずはリチャージアカウントを確認してください',
    'common-problem': 'よくある問題',
    'transaction-succeeded': '取引成功',
    'transaction-failed': '取引失敗',
    'transaction-cancel': '取引キャンセル',
    'whether-account': '1.チャージ後どのように入金を確認しますか?',
    'answer-whether-account': 'チャージ後、appの[マイ]-[ウォレット]に戻ってダイヤモンドを確認してください',
    'no-account': '2.チャージ後に入金していない場合はどうすればいいですか?',
    'answer-no-account': '"アプリの【メッセージ】-【公式ニュース】-【フィードバックとヘルプ】で質問を送信して、以下の情報を提供してください。その時カスタマーサービスがお手伝いします。"',
    'recharge-money': '1.チャージ金額とアカウントID',
    'recharge-time': '2.チャージ時間と日付',
    'recharge-shot': '3.支払い成功のスクリーンショット',
    'recharge-wrong': '3.アカウントと金額を間違った場合はどうすればいいですか',
    'answer-recharge-wrong': '決済パスワードを入力する前に、チャージアカウントのIDとチャージ金額情報をよくご確認の上、ご購入ください。金額を間違えてチャージする場合は返金できません。間違ったアカウントにチャージする場合は、実際にチャージしたIDユーザーに連絡して、相手とあなたにチャージ金額を補償するかどうか交渉してみてください。。',
    'refund': '4.返金',
    'answer-refund': 'すみません！BuzzCastは現在、いかなる形の返金にも対応していません。',
    'buy-enter-link': 'ダイヤモンドを購入してリンクを通じてチャージできます。<a class="web-link" href="https://pay.buzzcast.info">https://pay.buzzcast.info</a> リンクをコピーしてスマホのブラウザーで開き、購入ページに入り、アカウントを確認し、相応のチャージ種類を選択し、適切な支払い方法で支払います〜　たくさんの割引がありますよ！',
    'buy-notice-a': '注意：<a>{msg}</a> はBuzzCastの唯一の公式ダイヤモンド購入サイトです',
    'replace': '変更',
    'sureBtn': ' OK ',
    'pay-style': '支払い方法を選択してください',
    'goBack': 'ホームページに戻る',
    'toastTips': 'BuzzCast ID を入力します',
    'rechargeFAQ_title': 'よくある問題',
    'PayStatusSuccess_title': '取引成功',
    'PayStatusFail_title': '取引失敗',
    'PayStatusCancel_title': '取引キャンセル',
    'Diamonds_title': '{msg} ダイヤモンドリチャージ公式サイト',
    'buy-notice': '注: pay.buzzcast.info は BuzzCast の唯一の公式購入ダイヤモンド サイトであり、カスタマー サービスに関する問い合わせは[メッセージ] - [公式メッセージ] - [フィードバックとヘルプ]',
    'RechargeHelp_title': 'リチャージヘルプ',
    'openAPP': 'BuzzCastアプリを開く',
    'buy-diamonds-tit': 'ダイヤモンドサービスの購入',
    'description': 'BuzzCastは唯一の公式ダイヤモンドチャージサイトです。BuzzCastは、世界150カ国以上と地域のユーザーが利用している国際的なソーシャルソフトウェアです。',
    'keywords': 'BuzzCastチャージ、BuzzCastダイヤモンドチャージ、BuzzCast公式チャージ、BuzzCast公式チャージウェブサイト',
    'payforType': ' 充電方法',
    'trueText': 'OK',
    'falseText': 'キャンセル',
    'alertShowTxt1': '',
    'alertShowTxt3': '',
    'alertShowTxt5': 'を使用して%sダイヤモンドを再充電してもよろしいですか？',
    'EnterIDTip': '{msg}クイックリチャージ',
    'scanLogin': 'アカウントのプライバシーとセキュリティのために、コードをスキャンしてログインしてください',
    'scanTip': 'ヒント：BuzzCastの「パーソナルセンター/ダイナミクス」の右上隅にある「スキャン」をクリックして、コードをスキャンしてログインします。同時に、QRコードのスクリーンショットを識別してログインをサポートします。',
    'scanVersion': 'BuzzCastを％sバージョンにアップグレードし、コードをスキャンしてログインしてください',
    'delAccount': 'アカウントの削除',
    'logout': 'ログアウト',
    'submit': '提出',
    'email_place_holder': 'メールボックスを入力してください',
    'contact_email': '連絡先メールアドレス',
    'provide_email': '支払い通知を受け取るためのメールアドレスを入力してください',
    'email_address': '電子メールアドレス',
    'sel_country_area': '国家或いは地区をお選びください',
    'search_for': '検索',
    'login': 'ログインする',
    'scan_login': 'スキャンコードログイン',
    'account_password_error': '携帯番号或いは暗証番号が違います',
    'user_frozen': 'このユーザーはフリーズされています',
    'account_no_reg': 'アカウントは登録されていません',
    'login_no': 'あなたはログインしていません',
    'login_after_recharge': 'ログイン後に再チャージすることができます',
    'scan_login_lesson': 'スキャンコードログインのチュートリアル',
    'scan_login_desc': 'コードログインをスキャンする方法は、チャージウェブサイトのログインを迅速かつ安全に実現することができる。次の2つの方法では、コードをログインする方法をスキャンする方法を示します。',
    'scan_login_a_title': 'QRコードのスクリーンショットを認識してログインします',
    'scan_login_a_p1': '1.単一の装置のシナリオを使用するのに適しています。ユーザーはチャージウェブサイトのログインページを入力し、[コードをスキャンする]をクリックして[ログインする]を選択し、[ログインQRコード]のページのスクリーンショットを表示し、アルバムを保存します。 （スクリーンショット機能はデバイスごとにわずかに異なりますので、自分でスクリーンショット機能の操作指示を検索できます）',
    'scan_login_a_p2': '2.BuzzCastアプリを開き、「パーソナルセンター」または「動的」機能モジュールを介して、右上隅にある[スキャン]をクリックしてコードスキャン機能モジュールを入力します。',
    'scan_login_a_p3': '3.「アルバムの選択」をクリックしてアルバムの権限を使用し、保存されたQRコードのログインページを選択し、システムが認識した後、ブラウザに戻って待ってから待ってから待ってからユーザーがユーザーにロードされます。情報。',
    'scan_login_b_title': 'QRコードをスキャンしてログインします',
    'scan_login_b_p1': '1.複数の装置を使用するのに適しています。ユーザーはチャージウェブサイトのログインページを入力し、[スキャンコードログイン]をクリックします。',
    'scan_login_b_p2': '2.別のデバイスでBuzzCastアプリを開き、「パーソナルセンター」または「動的」機能モジュールに移動し、右上隅にある「スキャン」をクリックしてコードスキャン機能モジュールを入力します。',
    'scan_login_b_p3': '3.コードスキャンボックスをコードスキャンしたログインページのQRコードに合わせ、システムが認識した後の[ログイン]確認ボタンをクリックします（コードをスキャンするときにデバイス間で一定の距離を保持することをお勧めします。認識するシステムが。しばらくすると、ページは自動的にユーザー情報をロードします。',
    'scan_login_lesson_end': '上記はコードログインをスキャンするためのチュートリアルガイドで、私はあなたを助けたいと思います。カスタマーサービスの相談の場合は、アプリのメッセージ-公式のニュースフ-バックとヘルプを入力してください。',
    'or': '或いは',
    'input_phone_num': '電話番号は空にできません',
    'input_email': 'メールアドレスを入力してください',
    'input_password': '暗証番号を入力します',
    'log_in_using_Facebook': 'Facebookで登録します',
    'log_in_using_Google': 'Googleで登録します',
    'account_or_pwd_error': 'アカウントまたはパスワードが正しくありません',
    'pay_fail_system_risk': 'トランザクションが失敗しました：システムが異常です',
    'friendly_tip': '暖かいヒント',
    'i_got_it': 'わかった',
    'android_fblogin_tip': 'FacebookはAndroid組み込みブラウザでの認証ログインをサポートしなくなったため、この方法でログインするとログインできない場合があります。 このタイプのログインの問題が発生した場合は、Chromeブラウザを使用してアクセスしてください。',
    'recharge_tip': 'アカウント内の特定の数のダイヤモンドは、実際のリチャージ額の対象となります',
    'charge': 'チャージ',
    'link_add_mainpage': '次のリロードのためにホーム画面へのリンクを追加します',
    'click_me_to_add': '追加するにはクリックしてください',
    'user_has_delete': 'ユーザーはログアウトされました',
    'support_contant_whatsapp': 'サポートが必要な場合は、{msg} App のカスタマー サービスにお問い合わせください: 1924383',
    'buy_balance': '購入可能な残高：',
    'official_coin_seller': '公式コイン商人',
    'paystyle_unavailabel_change_other': 'システムに異常が発生したため、このお支払い方法は一時的にご利用いただけません。他のお支払い方法に変更してください。',
    'failedPay': '支払いに問題が発生し、支払いをやり直す',
    "copied": "コピー",
    "reseller": "代理店",
    "netword_busy_try": "ネットワークが混雑しています。もう一度お試しください",
    "placecommen": '検索語を入力してください',
    "app_all_v2": 'すべて',

		"use_phone_login": `電話でログイン`,
    "use_email_login": `メールでログイン`,
    "device_is_more": "このデバイスの登録アカウント数が上限に達しました",
    "Operation_failed": "アカウント違反のため、このデバイスは永久に凍結されています",
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/ja.js